<template>
    <ClientOnly>
        <div :ref="containerRef" class="layout-topbar">
            <div class="layout-topbar-inner">
                <div class="layout-topbar-logo-container flex-none">
                    <PrimeVueNuxtLink to="/" class="layout-topbar-logo" aria-label="PrimeVue logo">
                        <img src="/sgd.jpg" width="30"></img>
                        <span class="text-primary self-center ml-2 font-semibold">BẢN ĐỒ SỐ</span>
                    </PrimeVueNuxtLink>
                </div>
                <div class="grow hidden lg:block">
                    <Button :icon="isActive ? 'fa fa-bars-staggered' : 'fa fa-bars'" text size="large" @click="onMenuButtonClick"></Button>
                </div>
                <ul class="topbar-items flex-none">
                    <!-- <li>
                        <button type="button" class="topbar-item" @click="toggleDarkMode">
                            <i :class="['pi', { 'pi-moon': $appState.darkTheme, 'pi-sun': !$appState.darkTheme }]"></i>
                        </button>
                    </li> -->
                    <li class="relative">
                        <button
                            v-styleclass="{ selector: '@next', enterFromClass: 'hidden', enterActiveClass: 'animate-scalein', leaveToClass: 'hidden', leaveActiveClass: 'animate-fadeout', hideOnOutsideClick: true }"
                            type="button" class="topbar-item config-item">
                            <i class="pi pi-palette"></i>
                        </button>
                        <AppConfigurator />
                    </li>
                    <li v-if="showMenuButton && $route.path != '/'" class="menu-button">
                        <button type="button" class="topbar-item menu-button" @click="onMenuButtonClick" aria-haspopup
                            aria-label="Menu">
                            <i class="pi pi-bars"></i>
                        </button>
                    </li>
                    <li>
                        <button type="button" class="topbar-item" v-tooltip.bottom="'Đăng nhập'" @click="clicktoLogin"
                            v-if="status != 'authenticated'">
                            <i class="pi pi-user"></i>
                        </button>
                        <button type="button" class="topbar-item" @click="toggle" v-else>
                            <i class="pi pi-user"></i>
                        </button>
                        <Popover ref="menu">
                            <div class="flex flex-col gap-4 min-w-[15rem]">
                                <div>
                                    <button v-ripple
                                        class="relative overflow-hidden w-full p-link flex items-center p-2 pl-3 text-surface-700 dark:text-surface-0/80 hover:bg-surface-200 dark:hover:bg-surface-600 rounded-none">
                                        <Avatar
                                            :image="data.avatar ? 'data:image/png;base64,' + data.avatar : '/sgd.jpg'"
                                            class="mr-2" shape="circle" size="large" />
                                        <span class="inline-flex flex-col justify-start">
                                            <span class="font-bold">{{ data.username || 'Khác' }}</span>
                                            <span class="text-sm">{{ data.fullname || 'Người dùng' }}</span>
                                        </span>
                                    </button>
                                </div>
                                <div class="mt-1 z-50">
                                    <ul>
                                        <li v-for="item in itemsMenuToggle" :key="item.label"
                                            class="border-b border-gray-200 dark:border-gray-700">
                                            <div v-if="item.separator" class="my-2"></div>
                                            <div v-else>
                                                <div v-if="item.items">
                                                    <span class="block px-4 py-2 text-primary dark:text-gray-300">{{
                                                        item.label }}</span>
                                                    <ul>
                                                        <li v-for="subItem in item.items" :key="subItem.label"
                                                            class="px-6 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">
                                                            <router-link v-if="subItem.url" :to="subItem.url"
                                                                class="flex items-center">
                                                                <span :class="subItem.icon" class="mr-2"></span>
                                                                <span>{{ subItem.label }}</span>
                                                            </router-link>
                                                            <a v-else @click="subItem.command && subItem.command()"
                                                                class="flex items-center cursor-pointer">
                                                                <span :class="subItem.icon" class="mr-2"></span>
                                                                <span>{{ subItem.label }}</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <!-- <div v-else class="px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">
                                                    <router-link v-if="item.route" :to="item.route"
                                                        class="flex items-center">
                                                        <span :class="item.icon" class="mr-2"></span>
                                                        <span>{{ item.label }}</span>
                                                    </router-link>
                                                    <a v-else :href="item.url" :target="item.target"
                                                        class="flex items-center" @click="item.command && item.command()">
                                                        <span :class="item.icon" class="mr-2"></span>
                                                        <span>{{ item.label }}</span>
                                                    </a>
                                                </div> -->
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Popover>
                    </li>
                </ul>
            </div>
        </div>
    </ClientOnly>
</template>

<script setup>
import EventBus from '@/layouts/AppEventBus';
const { status, data, signOut } = useAuth()
// Props và emits
const props = defineProps({
    showMenuButton: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['menubutton-click', 'change-password']);

// Reactive variables
const menu = ref(null);
const container = ref(null);
const scrollListener = ref(null);
const outsideClickListener = ref(null);
const router = useRouter();

const itemsMenuToggle = ref([
    {
        separator: true
    },
    {
        label: 'Menu',
        items: [
            {
                label: 'Tổng quan',
                icon: 'pi pi-chart-bar',
                url: '/dashboard'
            },
            {
                label: 'Trường học',
                icon: 'fa fa-school',
                url: '/truong-hoc'
            },
            {
                label: 'Bản đồ',
                icon: 'fa fa-map',
                url: '/'
            }
        ]
    },
    {
        label: 'Hệ thống',
        items: [
            // {
            //     label: 'Thông tin',
            //     icon: 'pi pi-id-card',
            //     url: '/dashboard'
            // },
            {
                label: 'Đổi mật khẩu',
                icon: 'pi pi-key',
                command: async () => {
                    emit('change-password')
                },
            },
            {
                label: 'Đăng xuất',
                icon: 'pi pi-sign-out',
                command: async () => {
                    await signOut({ callbackUrl: '/', external: true })
                },
            }
        ]
    }
]);

// Methods
const isActive = ref(true)
const onMenuButtonClick = (event) => {
    isActive.value = !isActive.value
    emit('menubutton-click', event);
};

const toggle = (event) => {
    menu.value.toggle(event);
};

const toggleDarkMode = () => {
    EventBus.emit('dark-mode-toggle', { dark: !window.$appState.darkTheme });
};

const bindScrollListener = () => {
    if (!scrollListener.value) {
        if (container.value) {
            scrollListener.value = () => {
                if (window.scrollY > 0) container.value.classList.add('layout-topbar-sticky');
                else container.value.classList.remove('layout-topbar-sticky');
            };
        }
    }
    window.addEventListener('scroll', scrollListener.value);
};

const unbindScrollListener = () => {
    if (scrollListener.value) {
        window.removeEventListener('scroll', scrollListener.value);
        scrollListener.value = null;
    }
};

const bindOutsideClickListener = () => {
    if (!outsideClickListener.value) {
        outsideClickListener.value = (event) => {
            if (isOutsideTopbarMenuClicked(event)) {
                unbindOutsideClickListener();
            }
        };
        document.addEventListener('click', outsideClickListener.value);
    }
};

const unbindOutsideClickListener = () => {
    if (outsideClickListener.value) {
        document.removeEventListener('click', outsideClickListener.value);
        outsideClickListener.value = null;
    }
};

const isOutsideTopbarMenuClicked = (event) => {
    return !(container.value.contains(event.target));
};

const containerRef = (el) => {
    container.value = el;
};

const clicktoLogin = () => {
    router.push('/login');
};

// Lifecycle hooks
// onMounted(() => {
//     bindScrollListener();
// });

// onBeforeUnmount(() => {
//     unbindScrollListener();
//     unbindOutsideClickListener();
// });
</script>
